import mailDraftService from '../../../services/mailDraft.service'

export default {
    async getListMailDraft({dispatch, commit}, data) {
        return await mailDraftService.getListMailDraft(data)
            .then(response => {
                if (response.success && response.data) {
                    const listMailDraft = response.data.data
                    commit("SET_LIST_MAIL_DRAFT", listMailDraft)
                    return Promise.resolve(response.data);
                } else {
                    commit("SET_LIST_MAIL_DRAFT", [])
                    dispatch("alertError", response.message, { root: true });
                    return Promise.reject(response.message);
                }
            }).catch(error => {
                commit("SET_LIST_MAIL_DRAFT", [])
                return Promise.reject(false);
            })
    },
    async deleteMailDraft({commit, dispatch}, data){
        return mailDraftService.deleteMailDraft(data)
          .then(response => {
            dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
          })
          .catch(error =>{
            if(typeof error.errors == 'object'){
              if(Object.values(error.errors).length > 0){
                dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
              }
            }
            else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
          })
      },
    clearSearchFilter({commit}){
        commit('CLEAR_SERACH_FILTER')
    },
    async saveMailDraft({dispatch,commit}, mailData){
      return await mailDraftService.saveMailDraft(mailData)
          .then(response => {
              if (response.status  || response.success) {
                return Promise.resolve(response.data);
              } else {
                  return Promise.reject(false);
              }
          })
          .catch(error =>{
              return Promise.reject(false);
          })
    },
    setMode ({dispatch ,commit}){
      commit('SET_MODE');
    },
}